import React from 'react';

import Timer from './Components/Timer';


function App(): JSX.Element {
  return (
    <div className="App">
      <Timer />
     
    </div>
  );
}

export default App;
